import { createSelector } from 'reselect';
import { getView } from 'state/view/ViewSelectors';

export const getCustomVideoState = (state) => state.customVideo;

export const getCustomVideoEligibility = (state) =>
  state.customVideoEligibility;

export const getHasCustomVideo = createSelector(getView, (view) => {
  return {
    maryland529: view.hasMaryland529Video,
    national529: view.hasNational529Video
  };
});
